import { render, staticRenderFns } from "./RegSelf.vue?vue&type=template&id=31dc1520&scoped=true&"
import script from "./RegSelf.vue?vue&type=script&lang=js&"
export * from "./RegSelf.vue?vue&type=script&lang=js&"
import style0 from "./RegSelf.vue?vue&type=style&index=0&id=31dc1520&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc1520",
  null
  
)

export default component.exports